export function phone10(raw) {
  const d = String(raw || '').replace(/\D/g, '');
  if (d.length < 10) return '';
  return d.slice(-10);
}

export function formatPhone10(digits) {
  if (!digits || digits.length !== 10) return digits;
  return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
}

export function entriesFromApi(bl) {
  if (Array.isArray(bl?.entries) && bl.entries.length) {
    return bl.entries
      .map((e) => ({
        phone_digits: phone10(e.phone_digits || e.phone),
        name: String(e.name || '').trim(),
      }))
      .filter((e) => e.phone_digits);
  }
  return (bl?.phone_digits || [])
    .map((p) => ({
      phone_digits: phone10(p),
      name: '',
    }))
    .filter((e) => e.phone_digits);
}
